import Documents from './Documents.page';

export default Documents;